import React, { useEffect, useState } from "react";
import routes from "routes";
import { Switch, Route, Redirect } from "react-router-dom";
import PageLayout from "components/layout/PageLayout";
import NotFoundPage from "pages/errorPages/NotFoundPage";
import HomePage from "pages/home/HomePage";
import CreditsPage from "pages/credits/CreditsPage";
import ConfigContext from "contexts/ConfigContext";
import IAppConfig from "models/IAppConfig";
import NewsPageRoutes from "pages/news/routes";
import { backendApi } from "apiConsumers";

export default function App() {
    const [config, setConfig] = useState<IAppConfig | undefined>(undefined);
    // const [location, setLocation] = useState<CountryCode | undefined>(undefined);

    useEffect(() => {
        backendApi.getConfig().then((config) => {
            setConfig(config);
        });

        // backendApi.getIsoLocation().then((location) => setLocation(location));
    }, []);

    return (
        <ConfigContext.Provider value={config}>
            <Switch>
                <Redirect from="/preorder" to={`${routes.home.route}#${routes.home.anchors.buy}`} />
                {routes.home.route !== "/" ? (
                    <Route exact path="/" render={() => <Redirect to={routes.home.route} />} />
                ) : null}
                <Route
                    exact
                    path={routes.home.route}
                    render={() => (
                        <PageLayout toolbarProps={{ id: routes.home.anchors.root }}>
                            <HomePage />
                        </PageLayout>
                    )}
                />
                <Route path={routes.news.route} render={() => <NewsPageRoutes />} />
                <Route
                    exact
                    path={routes.credits.route}
                    render={() => (
                        <PageLayout>
                            <CreditsPage />
                        </PageLayout>
                    )}
                />
                <Route
                    render={() => (
                        <PageLayout>
                            <NotFoundPage />
                        </PageLayout>
                    )}
                />
            </Switch>
        </ConfigContext.Provider>
    );
}
